/// <amd-module name="Artifacts/Maven/components/MavenDevelopment" />
import { MavenCiConstants } from "Artifacts/Maven/Constants";
import * as MavenRes from "Artifacts/Maven/Resources";
import { PackageAttribute } from "Artifacts/Package/components/package-details-common/PackageAttribute";
import { IProjectAttribute } from "Artifacts/Package/components/package-details-common/PackageDevelopment";
import { PackageUpstreamSource } from "Artifacts/Package/components/package-details-common/PackageUpstreamSource";
import * as PackageRes from "Artifacts/Package/Resources";
import { ExternalLink } from "Artifacts/Root/components/ExternalLink";
import { CustomerIntelligenceHelper } from "Artifacts/Root/helpers/CustomerIntelligenceHelper";
import { htmlEncode } from "Artifacts/Root/helpers/HtmlHelper";
import { isSafeProtocol } from "Artifacts/Root/helpers/UrlHelper";
import { IMinimalPackageVersion, IPackage } from "Artifacts/Root/types";
import { UpstreamSourceIdentifier } from "Artifacts/Root/types/AzureArtifacts";
import * as React from "react";
import { IVssPageContext } from "VSS/Platform/Context";
import { Icon } from "VSSUI/Icon";

export interface IMavenDevelopmentProps {
  pageContext: IVssPageContext;
  buildAttribute?: IProjectAttribute | null;
  codeAttribute?: IProjectAttribute | null;
  projectAttributes?: IProjectAttribute[] | null;
  packageSummary: IPackage;
  packageVersion: IMinimalPackageVersion;
  upstreamSources?: UpstreamSourceIdentifier[];
}

export class MavenDevelopment extends React.PureComponent<IMavenDevelopmentProps> {
  public render(): JSX.Element {
    if (!this.showDevelopment()) {
      return <div />;
    }

    const { buildAttribute, codeAttribute, projectAttributes } = this.props;

    return (
      <div className="maven-development">
        <PackageAttribute title={MavenRes.MavenAttributes_DevelopmentTitle}>
          {this.props.upstreamSources && (
            <div>
              <div className="package-group-header" role="heading" aria-level={3}>
                {PackageRes.PackageSource}
              </div>
              <div className="package-attribute-item">
                <span className="package-attribute-item-icon">
                  <Icon iconName={"Package"} />
                </span>
                <PackageUpstreamSource
                  pageContext={this.props.pageContext}
                  packageSummary={this.props.packageSummary}
                  packageVersion={this.props.packageVersion}
                  upstreamSources={this.props.upstreamSources}
                />
              </div>
            </div>
          )}
          {buildAttribute && buildAttribute.text && (
            <div>
              <div className="package-group-header" role="heading" aria-level={3}>
                {MavenRes.MavenDevelopment_BuildHeading}
              </div>
              <div className="package-attribute-item" key={"build"}>
                <span className={"package-attribute-item-icon "}>
                  <Icon iconName={buildAttribute.iconClass} />
                </span>
                {isSafeProtocol(buildAttribute.url || "") ? (
                  <ExternalLink
                    pageContext={this.props.pageContext}
                    href={htmlEncode(buildAttribute.url || "")}
                    ciContext={MavenCiConstants.MavenDevelopment}
                    onClick={() =>
                      CustomerIntelligenceHelper.publishEvent(
                        this.props.pageContext,
                        buildAttribute.onClickCiFeature || "",
                      )
                    }
                  >
                    {buildAttribute.text}
                    <Icon iconName="NavigateExternalInline" />
                  </ExternalLink>
                ) : (
                  <span className="project-attibute-text">{buildAttribute.text}</span>
                )}
              </div>
            </div>
          )}
          {codeAttribute && codeAttribute.text && (
            <div>
              <div className="package-group-spacer" />
              <div className="package-group-header" role="heading" aria-level={3}>
                {MavenRes.MavenDevelopment_CodeHeading}
              </div>
              <div className="package-attribute-item" key={"code"}>
                <span className={"package-attribute-item-icon "}>
                  <Icon iconName={codeAttribute.iconClass} />
                </span>
                {isSafeProtocol(codeAttribute.url || "") ? (
                  <ExternalLink
                    pageContext={this.props.pageContext}
                    href={htmlEncode(codeAttribute.url || "")}
                    ciContext={MavenCiConstants.MavenDevelopment}
                    onClick={() =>
                      CustomerIntelligenceHelper.publishEvent(
                        this.props.pageContext,
                        codeAttribute.onClickCiFeature || "",
                      )
                    }
                  >
                    {codeAttribute.text}
                    <Icon iconName="NavigateExternalInline" />
                  </ExternalLink>
                ) : (
                  <span className="project-attibute-text">{codeAttribute.text}</span>
                )}
              </div>
            </div>
          )}
          {projectAttributes && projectAttributes.length > 0 && (
            <div>
              <div className="package-group-spacer" />
              <div className="package-group-header" role="heading" aria-level={3}>
                {MavenRes.MavenDevelopment_ProjectHeading}
              </div>
              {projectAttributes.map((projectAttribute: IProjectAttribute, index: number) => {
                return (
                  <div className="package-attribute-item" key={index}>
                    <span className={"package-attribute-item-icon "}>
                      <Icon iconName={projectAttribute.iconClass} />
                    </span>
                    {isSafeProtocol(projectAttribute.url || "") ? (
                      <ExternalLink
                        pageContext={this.props.pageContext}
                        href={htmlEncode(projectAttribute.url || "")}
                        ciContext={MavenCiConstants.MavenDevelopment}
                        onClick={() =>
                          CustomerIntelligenceHelper.publishEvent(
                            this.props.pageContext,
                            projectAttribute.onClickCiFeature || "",
                          )
                        }
                      >
                        {projectAttribute.text}
                        <Icon iconName="NavigateExternalInline" />
                      </ExternalLink>
                    ) : (
                      <span className="project-attibute-text">{projectAttribute.text}</span>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </PackageAttribute>
      </div>
    );
  }

  private showDevelopment(): boolean {
    return (
      this.props.upstreamSources != null ||
      (this.props.buildAttribute != null && this.props.buildAttribute.text != null) ||
      (this.props.codeAttribute != null && this.props.codeAttribute.text != null) ||
      (this.props.projectAttributes != null && this.props.projectAttributes.length > 0)
    );
  }
}
